var map = {
	"./img_0.png": 656,
	"./img_1.png": 657,
	"./img_2.png": 658,
	"./img_3.png": 659,
	"./img_4.png": 660,
	"./img_5.png": 661,
	"./img_6.png": 662,
	"./img_7.png": 663,
	"./img_8.png": 664
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 655;